<template>
  <el-container class="layout-container" direction="vertical">
    <el-header class="header">
      <div class="logo"><img src="/logo.svg" class="logo-img" alt="渤泰云 ERP" /><span>渤泰云 ERP</span></div>
      <el-menu
        :default-active="activeMenu"
        router
        mode="horizontal"
        ellipsis
        class="el-menu-horizontal"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/dashboard">
          <el-icon><HomeFilled /></el-icon>
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/ai-chat" @click.capture="onAiMenuClick">
          <el-icon><MagicStick /></el-icon>
          <span>AI助手</span>
        </el-menu-item>
        <el-menu-item index="/ai-growth" @click.capture="onGrowthMenuClick">
          <el-icon><Promotion /></el-icon>
          <span>AI获客</span>
        </el-menu-item>
        <el-sub-menu index="/purchase">
          <template #title>
            <el-icon><ShoppingCart /></el-icon>
            <span>采购管理</span>
          </template>
          <el-menu-item index="/purchase-orders">采购订单</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/sales">
          <template #title>
            <el-icon><Document /></el-icon>
            <span>销售管理</span>
          </template>
          <el-menu-item index="/sales-orders">销售订单</el-menu-item>
          <el-menu-item index="/quotations">报价管理</el-menu-item>
          <el-menu-item index="/contract">合同管理</el-menu-item>
          <el-menu-item index="/referrers">介绍人管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/customer">
          <template #title>
            <el-icon><UserFilled /></el-icon>
            <span>客户管理</span>
          </template>
          <el-menu-item index="/customers">客户列表</el-menu-item>
          <el-menu-item index="/leads">线索管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/task-center">
          <template #title>
            <el-icon><Tools /></el-icon>
            <span>任务中心</span>
          </template>
          <el-menu-item index="/todos">全部待办</el-menu-item>
          <el-menu-item index="/todos/internal">内勤任务</el-menu-item>
          <el-menu-item index="/crm/follow-up-tasks">跟进任务</el-menu-item>
          <el-menu-item index="/work-orders">安装工单</el-menu-item>
          <el-menu-item index="/work-orders/install-records">安装记录</el-menu-item>
          <el-menu-item index="/work-orders/install-daily">安装日报</el-menu-item>
          <el-menu-item index="/work-orders/install-pending">未报安装预警</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/product">
          <template #title>
            <el-icon><Goods /></el-icon>
            <span>产品管理</span>
          </template>
          <el-menu-item index="/products">产品列表</el-menu-item>
          <el-menu-item index="/categories">商品分类</el-menu-item>
          <el-menu-item v-if="hasPermission('supplier:read')" index="/suppliers">供应商</el-menu-item>
          <el-menu-item index="/logistics-companies">物流公司</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/crm">
          <template #title>
            <el-icon><DataLine /></el-icon>
            <span>CRM管理</span>
          </template>
          <el-menu-item index="/crm/dashboard">仪表盘</el-menu-item>
          <el-menu-item index="/crm/grading">客户分级</el-menu-item>
          <el-menu-item index="/crm/churn-warning">流失预警</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/finance">
          <template #title>
            <el-icon><Money /></el-icon>
            <span>财务管理</span>
          </template>
          <el-menu-item index="/finance">资金账户</el-menu-item>
          <el-menu-item index="/finance/payment-approval">收款审批</el-menu-item>
          <el-menu-item index="/finance/reports">财务报表</el-menu-item>
          <el-menu-item index="/finance/expense-claims">费用报销</el-menu-item>
          <el-menu-item index="/finance/expense-categories">报销类型</el-menu-item>
          <el-menu-item v-if="hasPermission('finance:income')" index="/finance/other-incomes">其他收入</el-menu-item>
          <el-menu-item v-if="hasPermission('finance:income-category')" index="/finance/income-categories">收入科目</el-menu-item>
          <el-menu-item index="/finance/invoices">发票管理</el-menu-item>
          <el-menu-item index="/finance/installments">分期付款</el-menu-item>
          <el-menu-item index="/finance/reconciliations">客户对账</el-menu-item>
          <el-menu-item index="/finance/supplier-reconciliations">供应商对账</el-menu-item>
          <el-menu-item index="/finance/logistics-reconciliations">物流对账</el-menu-item>
          <el-menu-item index="/finance/rebates">返点管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/reports">
          <template #title>
            <el-icon><Histogram /></el-icon>
            <span>报表中心</span>
          </template>
          <el-menu-item index="/reports">销售报表</el-menu-item>
          <el-menu-item index="/reports/purchase">采购报表</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/inventory">
          <template #title>
            <el-icon><Box /></el-icon>
            <span>库存管理</span>
          </template>
          <el-menu-item index="/inventory/warehouses">仓库管理</el-menu-item>
          <el-menu-item index="/inventory/stock">库存查询</el-menu-item>
          <el-menu-item index="/inventory/flows">库存流水</el-menu-item>
          <el-menu-item index="/inventory/stock-warning">库存预警</el-menu-item>
          <el-menu-item index="/inventory/transfers">仓库调拨</el-menu-item>
          <el-menu-item index="/returns">退货管理</el-menu-item>
          <el-menu-item index="/inventory/stocktakes">库存盘点</el-menu-item>
          <el-menu-item index="/inventory/inbounds">入库管理</el-menu-item>
          <el-menu-item index="/inventory/outbounds">出库管理</el-menu-item>
          <el-menu-item v-if="locationEnabled" index="/inventory/locations">库位管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/schedule">
          <template #title>
            <el-icon><Calendar /></el-icon>
            <span>日程管理</span>
          </template>
          <el-menu-item index="/schedule">日程日历</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/hr">
          <template #title>
            <el-icon><User /></el-icon>
            <span>人力资源</span>
          </template>
          <el-menu-item index="/hr/employees">员工管理</el-menu-item>
          <el-menu-item index="/hr/commissions">销售提成</el-menu-item>
          <el-menu-item index="/hr/performance">绩效评估</el-menu-item>
          <el-menu-item index="/hr/salary">工资核算</el-menu-item>
          <el-menu-item index="/hr/tools">工具领用</el-menu-item>
          <el-menu-item index="/hr/attendance">考勤管理</el-menu-item>
          <el-menu-item index="/hr/approval-submit">审批提交</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="/system">
          <template #title>
            <el-icon><Setting /></el-icon>
            <span>系统管理</span>
          </template>
          <el-menu-item index="/system/users">用户管理</el-menu-item>
          <el-menu-item index="/system/roles">角色管理</el-menu-item>
          <el-menu-item index="/system/operation-logs">操作日志</el-menu-item>
          <el-menu-item index="/system/images">图片管理</el-menu-item>
          <el-menu-item index="/system/print-templates">打印模板</el-menu-item>
          <el-menu-item index="/system/settings">系统设置</el-menu-item>
          <el-menu-item index="/system/setup-wizard">建账向导</el-menu-item>
          <el-menu-item index="/system/install-category-rates">安装类别费率</el-menu-item>
          <el-menu-item index="/system/import-export">导入导出</el-menu-item>
          <el-menu-item index="/system/backup">数据备份</el-menu-item>
          <el-menu-item index="/system/wework-config">企业微信配置</el-menu-item>
          <el-menu-item index="/system/wework-rules">企微消息规则</el-menu-item>
        </el-sub-menu>
      </el-menu>
      <div class="header-right">
        <el-tooltip content="使用帮助" placement="bottom">
          <el-icon class="help-btn" @click="helpDrawerRef?.open()"><QuestionFilled /></el-icon>
        </el-tooltip>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ authStore.userInfo?.realName || authStore.userInfo?.username }}
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    <!-- 系统内帮助抽屉（按当前页面匹配帮助内容） -->
    <HelpDrawer ref="helpDrawerRef" />
    <el-main class="main">
      <!-- 销售订单列表缓存：从退货单等详情返回时保留筛选/分页/滚动位置（组件内 onActivated 刷新数据） -->
      <router-view v-slot="{ Component }">
        <keep-alive :include="['SalesOrderList']">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </el-main>
    <!-- AI 助手悬浮窗（有 ai:use 权限且系统开启 AI 时自动显示） -->
    <AiAssistant />
  </el-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AiAssistant from '@/components/ai/AiAssistant.vue'
import HelpDrawer from '@/components/HelpDrawer.vue'
import { checkAiAvailable } from '@/utils/aiGate'
import { useLocationEnabled } from '@/utils/locationFeature'
import { hasPermission } from '@/utils/permission'
import { HomeFilled, Document, UserFilled, Goods, User, DataLine, Tools, Box, Money, ShoppingCart, Setting, Calendar, Histogram, MagicStick, QuestionFilled, Promotion } from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const helpDrawerRef = ref<InstanceType<typeof HelpDrawer>>()

// 库位管理菜单：租户开启库位功能才显示
const locationEnabled = useLocationEnabled()

// AI 菜单入口：常显（可发现性），点击时实时校验 AI 状态，不可用则告知原因且不跳转
async function onAiMenuClick(e: MouseEvent) {
  e.preventDefault()
  e.stopPropagation()
  if (await checkAiAvailable({ featureName: 'AI 助手' })) {
    router.push('/ai-chat')
  }
}

// AI获客入口:同上,但无 ai:growth 权限时静默放行由路由守卫拦截(提示语保持一致)
async function onGrowthMenuClick(e: MouseEvent) {
  e.preventDefault()
  e.stopPropagation()
  if (await checkAiAvailable({ featureName: 'AI获客' })) {
    router.push('/ai-growth')
  }
}

const activeMenu = computed(() => route.path)

const handleCommand = (command: string) => {
  if (command === 'logout') {
    authStore.logout()
  }
}
</script>

<style scoped lang="scss">
.layout-container {
  height: 100vh;
}

.header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: #304156;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  .logo {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    margin-right: 20px;
    flex-shrink: 0;
    white-space: nowrap;

    .logo-img {
      width: 28px;
      height: 28px;
    }
  }
}

.el-menu-horizontal {
  flex: 1;
  min-width: 0;
  border-bottom: none;
}

.header-right {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 16px;

  .help-btn {
    cursor: pointer;
    color: #bfcbd9;
    font-size: 20px;

    &:hover {
      color: #fff;
    }
  }

  .user-info {
    cursor: pointer;
    color: #bfcbd9;
  }
}

.main {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>

